<template>
  <div class="ProgressBar" :style="{ '--progress': `${Math.round(100 * progress)}%` }"></div>
</template>

<script>
export default {
  props: {
    progress: Number,
  },
}
</script>

<style scoped>

@property --progress {
  syntax: '<percentage>';
  inherits: false;
  initial-value: 0%;
}

.ProgressBar {
  height: 0.5rem;
  border-radius: 999px;
  transition: --progress 0.25s;
  background-image: linear-gradient(
    to right,
    var(--brand-color) var(--progress),
    var(--bg-color-white) var(--progress)
  );
}
</style>
